module.exports = __webpack_public_path__ + "static/media/logo_magma.64010402.jpg";